import { render, staticRenderFns } from "./HeadlineBlocks.vue?vue&type=template&id=27c346d0&scoped=true"
import script from "./HeadlineBlocks.vue?vue&type=script&lang=ts"
export * from "./HeadlineBlocks.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineBlocks.vue?vue&type=style&index=0&id=27c346d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c346d0",
  null
  
)

export default component.exports